import { useCallback } from "react";
import CONFIG from "../config/config";
import { getAuthHeaders } from "../misc.js";

const useVoiceGenerator = (voiceId) => {
  const generateVoice = useCallback(async (text) => {
    const response = await fetch(`${CONFIG.API_URL}/generate/voice`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ text, voiceId }),
    });

    if (!response.ok) {
      throw new Error("Error generating voice");
    }

    const data = await response.json();
    return data.voice;
  }, [voiceId]);

  return generateVoice;
};

export default useVoiceGenerator;
